import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import qs from "qs";
import Lock from "@material-ui/icons/Lock";
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import Button from "@material-ui/core/Button/Button";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { userAction } from "../../actions/user.action";
import ErrorMessage from "../../components/UI/ErrorMessage";
import CenteredContent from "../../components/UI/CenteredContent";

const styles = (theme) => ({
  cta: {
    marginTop: theme.spacing(2),
  },
  content: {
    height: theme.wbiComponent.login.formHeight,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  disabledTab: {
    "&&": {
      color: `${theme.palette.primary.main}`,
    },
  },
});

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    const parsedQueryString = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.state = {
      email: parsedQueryString.email,
      token: parsedQueryString.token,
      password: "",
      confirmPassword: "",
      passwordsMatch: true,
    };
  }

  handleChange = (name) => (e) => {
    e.preventDefault();
    const { value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (
      this.state.password &&
      this.state.password !== this.state.confirmPassword
    ) {
      this.setState({ passwordsMatch: false });
    } else {
      this.setState({ passwordsMatch: true });
      this.props.dispatch(userAction.resetPassword(this.state));
    }
  };

  render() {
    const { classes, user } = this.props;

    return (
      <CenteredContent
        headerContent={
          <Tabs
            value={0}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              label="Change Password"
              disabled
              classes={{ disabled: classes.disabledTab }}
            />
          </Tabs>
        }
      >
        {user.resetPasswordResult ? (
          <div className={classes.content}>
            <div>
              <Typography color="primary" variant="body2">
                {user.resetPasswordResult}
              </Typography>
            </div>
            <div>
              <Link to="/login">
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.cta}
                >
                  Login
                </Button>
              </Link>
            </div>
          </div>
        ) : (
          <form className={classes.content} onSubmit={this.handleSubmit}>
            <div>
              {user.resetPasswordError && (
                <React.Fragment>
                  <ErrorMessage>{user.resetPasswordError}</ErrorMessage>
                  Running into problems?{" "}
                  <Link
                    to={`/forgot-password`}
                    style={{ textDecoration: "underline" }}
                  >
                    Request another password reset
                  </Link>
                </React.Fragment>
              )}
              {!this.state.passwordsMatch && (
                <ErrorMessage>Passwords must match.</ErrorMessage>
              )}
              <TextField
                label="Password"
                type="password"
                onChange={this.handleChange("password")}
                value={this.state.password}
                margin="normal"
                required
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Confirm Password"
                type="password"
                onChange={this.handleChange("confirmPassword")}
                value={this.state.confirmPassword}
                margin="normal"
                required
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.cta}
                disabled={user.resettingPassword}
              >
                Change Password
              </Button>
            </div>
          </form>
        )}
      </CenteredContent>
    );
  }
}

ResetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withStyles(styles)(connect(mapStateToProps)(ResetPassword));



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/index.jsx